// extracted by mini-css-extract-plugin
export default {"thead":"CapacityTable_thead__ibQKY","tbody":"CapacityTable_tbody__QNXVs"};